export default __webpack_public_path__ + "static/badgeTrophy-3b1e552d30968eb6829e2b87ec45f277.png";